export enum TipoPerfil {
  consignataria = "Consignatária",
  patrocinadora = "Patrocinadora",
}